// extracted by mini-css-extract-plugin
export default {"signatureModalLine":"src-signer-app-signature-modal-common-signature-modal-line-module__signatureModalLine--2bNIp"};